import moment from "moment";
// -
const DateTimesUtils = {
    MILLISECONDS_PER_DAY: 1000 * 60 * 60 * 24,

    differenceDays: function (now, past) {
        if (now === null || past === null || now === "" || past === "") {
            console.error("Invalid date");
            return 0;
        }
        if (!(now instanceof Date) || !(past instanceof Date)) {
            console.error("Invalid date objects");
            return 0;
        }

        let diff = now - past;
        return Math.floor(diff / this.MILLISECONDS_PER_DAY);
    },
    minutesToTime: function (minutes) {
        if (minutes === null || minutes === "" || isNaN(minutes)) {
            console.error("Invalid minutes");
            return "00:00";
        }
        let hours = ("0" + Math.floor(minutes / 60)).slice(-2);
        let minutesRest = ('0' + minutes % 60).slice(-2);
        return hours + ":" + minutesRest;
    },
    timeToMinutes: function (time) {
        if (time === null || time === "") {
            console.error("Invalid time");
            return 0
        }
        if (!time.includes(":")) {
            console.error("Invalid time format");
            return 0;
        }
        let minutes = time.split(/:/).map(Number);
        return minutes[0] * 60 + minutes[1]
    },
    sleep: (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    },
    dayMonthPlace: (datedInput) => {
        const dated = moment.isMoment(datedInput)
            ? datedInput
            : moment(datedInput, "YYYY-MM-DD");
        if (!dated.isValid()) {
            console.error("Invalid date input");
            return 0;
        }
        const weekday = parseInt(dated.format("d"));
        let counter = 0;

        // first day month
        let initMonth = moment(dated).startOf("month");

        // Iterar por los días del mes hasta la dated
        while (initMonth.isSameOrBefore(dated, "day")) {
            if (parseInt(initMonth.format("d")) === weekday) {
                counter++;
            }
            initMonth.add(1, "day");
        }
        return counter;
    },
    lastDayMonth: (fecha, weekday) => {
        const dated = moment.isMoment(fecha) ? fecha : moment(fecha, "YYYY-MM-DD");
        if (!dated.isValid()) {
            console.error("Fecha inválida");
            return null;
        }
        let lastDay = dated.clone().endOf("month");
        while (lastDay.day() !== weekday) {
            lastDay.subtract(1, "day");
        }
        // Day number of month
        return lastDay.date();
    },
    timeToHourMinute: (time) => {
        let time_ = time.split(":");
        return time_[0] + ":" + time_[1];
    }
}

export default DateTimesUtils;